import React, { Suspense } from 'react'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import useToggleState from 'src/hooks/useToggleState'
import Body from './Body'
import List from './List'
import EditModel from './EditModal'

interface BenefitsProps {
  id: string
}

const Benefits: React.FC<BenefitsProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()

  return (
    <>
      <Card
        title='Benefits'
        primaryAction={{
          key: 'edit',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<List agency={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default Benefits
